import { getModuleByStoreType } from '../modules/registry';

export const getRoutesByStoreType = (storeType) => {
  const activeModule = getModuleByStoreType(storeType);
  return {
    defaultPath: activeModule.defaultPath || '/dashboard',
    routes: activeModule.routes || [],
  };
};
